import _ from "lodash";

// `context` is a React class component instance (setState/state); `e` is a DOM
// event. Both are genuinely dynamic legacy shapes, typed as `any`.
export function checkDuplicate(val = "", list: any[] = [], fieldName = "", context: any = {}, e?: any) {
  const index = _.findIndex(list, (item: any) => {
    return item[fieldName].toLowerCase() === val.toLowerCase();
  });
  const errorMsg = index >= 0 ? `${fieldName} already exists` : "";
  console.log("checkDuplicate: ", fieldName, errorMsg, val, list);
  console.log("checkDuplicate2: ", e, e.target);
  const foo = e.target.hasAttribute("required");
  const boo = e.target.hasAttribute("requiredd");
  console.log("checkDuplicate3: ", foo, boo);

  context.setState({
    errorMsg: {
      [fieldName]: errorMsg
    }
  });
}

export function checkError(e: any, list: any[] = [], fieldName = ""): string {
  const val = e.target.value;
  console.log("checkError: ", val, list);
  const isRequired = e.target.hasAttribute("required");
  if (isRequired && !val) {
    return "cannot be empty";
  }
  const index = _.findIndex(list, (item: any) => {
    return (item[fieldName] || "").toLowerCase() === val.toLowerCase();
  });

  console.log("checkError: ", index);
  return index >= 0 ? `${fieldName} already exists` : "";
}

export function onPeriodChange(val: any, propertyName: string, checked: boolean, context: any) {
  const cloned = _.cloneDeep(context.state.formData);

  if (checked) {
    cloned[propertyName].value.push(val);
  } else {
    // remove
    cloned[propertyName].value = cloned[propertyName].value.filter((item: any) => parseInt(item) !== parseInt(val));
  }
  context.setState({
    formData: cloned
  });
}

export function hasError(errorMsg: string[] | Record<string, string> = []): boolean {
  const msg = _.reduce(
    errorMsg as Record<string, string>,
    (sum: string, n: string = "") => {
      return sum + n;
    },
    ""
  );

  console.log("hasError: ", !!msg, msg, errorMsg);

  return !!msg;
}

export function isEmpty(state: any[] = []): boolean {
  // onEmpty(!!!val);

  const hasStuff = _.every(state, (item: any) => {
    let hasValue = false;

    switch (typeof item) {
      case "string":
        hasValue = !!item;
        break;
      case "number":
        hasValue = !!item || item === 0;
        break;
      case "object":
        hasValue = !!_.get(item, 'length', 0);
        break;
      default:
        break;
    }

    return hasValue;
  });

  console.log("isEmpty: ", !hasStuff, state);
  return !hasStuff;
}
